import { useState } from "react";
import { useTranslation } from "react-i18next";
import { X, Check } from "lucide-react";
import { NeuButton, NeuInput } from "../../components/neu/Neu";
import { SignaturePad } from "../purchase/SignaturePad";

// حوار توقيع (شاشة كاملة) — Canvas بحبر أزرق #0066CC + ملاحظة اختيارية.
export const SignDialog = ({ title, hue, keeperName, hint, busy, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [signature, setSignature] = useState("");
  const [note, setNote] = useState("");
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/60 p-4"
         data-testid="sign-dialog">
      <div className="w-full max-w-xl overflow-hidden rounded-3xl bg-background shadow-2xl">
        <div className={`flex items-center justify-between bg-gradient-to-r ${hue} px-5 py-3 text-white`}>
          <p className="text-lg font-black">{title}</p>
          <button onClick={onCancel} data-testid="sign-close"
                  className="rounded-full bg-white/15 p-2 hover:bg-white/25"><X className="h-5 w-5" /></button>
        </div>
        <div className="grid gap-3 p-5">
          <div className="rounded-2xl bg-primary/5 p-3 text-xs">
            <p>{t("sign.keeper")}: <strong className="text-primary">{keeperName || "—"}</strong></p>
            {hint ? <p className="mt-1 text-[11px] text-muted-foreground">{hint}</p> : null}
          </div>
          <p className="label-xs">{t("sign.drawHint")}:</p>
          <div className="rounded-2xl bg-white p-2 shadow-neu-in">
            <SignaturePad onChange={setSignature} />
          </div>
          <NeuInput data-testid="sign-note" value={note} placeholder={t("sign.notePh")}
                    onChange={(e) => setNote(e.target.value)} />
          <div className="flex justify-end gap-2 border-t border-border/40 pt-3">
            <NeuButton onClick={onCancel}>{t("app.cancel")}</NeuButton>
            <NeuButton data-testid="sign-confirm" disabled={!signature || busy}
                       onClick={() => onConfirm({ signature, note })}
                       className="bg-emerald-500 text-white hover:bg-emerald-600">
              <Check className="inline h-4 w-4" /> {t("sign.confirm")}
            </NeuButton>
          </div>
        </div>
      </div>
    </div>
  );
};
